<script setup lang="ts">
    import { InputRow, Select, DatePicker } from '@/components/ui/form';

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3 sm:grid-cols-1">
        <InputRow
            :form="form"
            name="period"
            label="system.vat_deadlines_header"
        >
            <Select
                v-model="form.period"
                :options="[
                    { value: 'monthly', label: 'companies.vat_frequency_options.monthly' },
                    { value: 'quarterly', label: 'companies.vat_frequency_options.quarterly' },
                    { value: 'six-monthly', label: 'companies.vat_frequency_options.six-monthly' },
                ]"
                :translate="true"
            />
        </InputRow>
        <div class="grid grid-cols-2 gap-3">
            <InputRow
                :form="form"
                name="settlement_period_from"
                label="system.settlement_period_from"
            >
                <DatePicker v-model="form.settlement_period_from" />
            </InputRow>
            <InputRow
                :form="form"
                name="settlement_period_to"
                label="system.settlement_period_to"
            >
                <DatePicker v-model="form.settlement_period_to" />
            </InputRow>
        </div>
        <InputRow
            :form="form"
            name="deadline"
            label="system.vat_deadlines.deadline"
        >
            <DatePicker v-model="form.deadline" />
        </InputRow>
    </div>
</template>
